import React from 'react'
import styled from 'styled-components/macro'

import talShort from './tal-short.svg'
import talFull from './healthscout.svg'
import talFullWhite from './tal-full-white.svg'
import notebook from './notebook-arrow.svg'
import cbus from './cbus.png'
import margin from '../../styles/margin'

const Wrapper = styled.img`
  ${margin};
`

const Cbus = styled.img`
  ${margin};
  max-width: 56px;
`

const getVersion = (version) => {
  switch (version) {
    case 'short':
      return talShort
    case 'full':
      return talFull
    case 'white full':
      return talFullWhite
    case 'notebook':
      return notebook
    default:
      return talShort
  }
}

const Logo = ({ version, ...styles }) =>
  version === 'cbus' ? (
    <Cbus src={cbus} {...styles} alt='Cbus' />
  ) : (
    <Wrapper src={getVersion(version)} {...styles} alt='Tal' />
  )

export default Logo
